import * as React from 'react';
import { ChangeEvent, RefObject } from 'react';
// @ts-ignore
import readExcelFile from 'read-excel-file';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { connect } from 'react-redux';
import ProductModel from '../../domain/Product';
import '../estimations/export/ExcelButtons.css';
import importIcon from '../img/import.svg';
import ExcelImportWrongFileLoaded from '../../application/core/events/ExcelImportWrongFileLoaded';

interface Props {
    products: ProductModel[];
    name: 'Estimations' | 'Order';
    importExcel: (rows: string[][]) => void;
}

class ImportExcel extends React.PureComponent<DispatchProps & Props> {
    public importFile: RefObject<HTMLInputElement> = React.createRef();

    public render(): JSX.Element {
        const className = 'estimations-import link-button button-' + this.props.name.toString().toLowerCase();
        return (
            <button className={className} onClick={this.onClick}>
                <label>
                    <input
                        ref={this.importFile}
                        type="file"
                        className="estimations-import-input"
                        onChange={this.onImport}
                        multiple={true}
                    />
                </label>
                <img src={importIcon} className="export-button-icon" />
                <span>(.xls)</span>
            </button>
        );
    }

    private onClick = (): void => {
        this.importFile.current!.value = '';
    };

    private onImport = (event: ChangeEvent<HTMLInputElement>): void => {
        if (event.target.files && event.target.files[0] !== undefined) {
            const file = event.target.files[0];
            return readExcelFile(file)
                .then((rows: string[][]) => {
                    this.props.importExcel(rows);
                })
                .catch(() => {
                    this.props.dispatch(new ExcelImportWrongFileLoaded());
                });
        }
    };
}

export default connect(mapDispatchToProps)(ImportExcel);



// WEBPACK FOOTER //
// ./src/view/common/ImportExcel.tsx